import React, { Component } from 'react';
import WrapperCalculator from '../../content/nrwmanagement/wrapper-calculator/wrapper-calculator.component';

class NRWCalculatePage extends Component {
    render() {
        return (
            <div className="wrapper-dashboard-page">
                <h1 className="page-name-header">NRW Calculator</h1>
                {/* <p className="content-test">Lorem ipsum dolor sit amet, consectetur adipiscing elit. ae risus tristique posuere.</p> */}
                <WrapperCalculator></WrapperCalculator>
                
            </div>
        )
    }
}

export default NRWCalculatePage
